import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/badge-nfc`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async create({ commit }, payload: { userId: number }) {
    return axiosInstance.post(baseUrl, payload).then((data) => data.data);
  },

  async getByUserId({ commit }, payload) {
    return axiosInstance.get(baseUrl, { params: payload }).then((data) => data.data);
  },

  async delete({ commit }, payload: { id: number }) {
    return axiosInstance.delete(baseUrl + "/" + payload.id).then((data) => data.data);
  },

  async enable({ commit }, payload: { id: number }) {
    return axiosInstance.put(baseUrl + "/" + payload.id + "/enable").then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
